import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: `/`,
            name: '全部',
            component: re => require(['@/components/LayContentAll.vue'], re),
            redirect: 'home',
            children: [
                {
                    path: `/home`,
                    meta: {
                        title: '首页'
                    },
                    component: () => import('../views/Index/Index.vue'),
                },
                {
                    path: `/adminManage`,
                    meta: {
                        title: '管理员管理'
                    },
                    component: () => import('../views/adminManage/index.vue'),
                },
                {
                    path: `/teacherManage`,
                    meta: {
                        title: '编辑管理'
                    },
                    component: () => import('../views/teacherManage/index.vue'),
                },
                {
                    path: `/userManage`,
                    meta: {
                        title: '作者管理'
                    },
                    component: () => import('../views/userManage/index.vue'),
                },
                {
                    path: `/experManage`,
                    meta: {
                        title: '专家管理'
                    },
                    component: () => import('../views/experManage/index.vue'),
                },
                {
                    path: `/dataManage`,
                    meta: {
                        title: '稿件管理'
                    },
                    component: () => import('../views/dataManage/index.vue'),
                },
                {
                    path: `/manuscriptType`,
                    meta: {
                        title: '稿件类型管理'
                    },
                    component: () => import('../views/manuscriptType/index.vue'),
                },
                {
                    path: `/doHandledb`,
                    meta: {
                        title: '待办稿件'
                    },
                    component: () => import('../views/doHandle/doHandledb.vue'),
                },
                {
                    path: `/doHandleyb`,
                    meta: {
                        title: '已办稿件'
                    },
                    component: () => import('../views/doHandle/doHandleyb.vue'),
                },
                {
                    path: `/doHandlezzb`,
                    meta: {
                        title: '正在办稿件'
                    },
                    component: () => import('../views/doHandle/doHandlezzb.vue'),
                },
            ]
        },
        {
            path: `/login`,
            name: '登录',
            meta: {
                title: '登录',
                type: 0,//用于记录用户行为  1书籍 2杂志
            },
            component: re => require(['../views/Login.vue'], re),
        }
    ],
    // mode: 'history',
})
